import { useCallback } from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';

/** Texts of Banka Hesapları (`bankAccounts.*`). Stored values stay as typed. */
const useBankAccountText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`bankAccounts.${key}`, vars), [t]);
  return { t, language, locale, label };
};

export default useBankAccountText;
